export const PAGE_PATHS = {
  CONTENT_PERMISSIONS: 'content-permissions',
  MODEL_MANAGEMENT: 'model-management',
  DATA_UNIFICATION_FIELDS: 'fields',
  ALL_ACCOUNTS: 'all-accounts', // done
  EDIT_MY_ACCOUNT_MANAGEMENT: 'account-settings',
  USER_MANAGEMENT: 'user-management',
  ACCOUNT_USAGE: 'account-usage',
  ALL_USERS: 'all-users',
  EDIT_MY_USER: 'profile-settings',
  GLOBAL_SCRIPTS: 'global-scripts',
  TARGETS: 'targets',
  LOGS: 'logs',
  ALERTS: 'alerts',
  RULES: 'rules',
  SOURCES: 'sources',
  TICKETS: 'tickets',
  THREAT_DASHBOARD: 'dashboard',
  INCIDENTS: 'incidents',
  FINDINGS: 'findings',
  ASSETS: 'assets',
  WORKFLOWS: 'workflows',
  QUERY: 'query',
  SETTINGS: 'settings',
  RULE_SET: 'rule-set',
  SEVERITY_SLA: 'severity-sla',
  SEVERITY: 'severity',
  SLA: 'sla',
  TICKETS_STATUSES: 'tickets-statuses',
  UI_CONFIG: 'ui-config',
  ENTITIES: 'entities',
  LOOKUP_TABLES: 'lookup-tables',
  REMEDIATION: 'remediation',
  RISK: 'risk',
  ASSET_COVERAGE: 'asset-coverage',
  PIVOT: 'pivot',
  OVERVIEW: 'overview',
  SCORE: 'score',
  TEST_QUERY: 'test-query',
  REPORTS: 'reports',
  BACKOFFICE_ACTIONS: 'backoffice-actions',
  CUSTOM_DASHBOARDS: 'dashboards',
  ALIASES: 'aliases',
  RELATIONS: 'relations',
  ENTITIES_TO_LOGS: 'entities-to-logs',
  PERMISSIONS: 'permissions',
  ROLES: 'roles',
  SOURCES_MAPPING: 'data-mapping',
  MEASUREMENTS: 'measurements',
  FACTOR_RULES: 'factor-rules',
  GLOBAL_FACTOR_RULES: 'global-factor-rules',
  ICONS: 'icons',
  POLICY_COMPLIANCE: 'policy-compliance',
  ASSET_INVENTORY: 'asset-inventory',
  POLICY_VIOLATIONS: 'policy-violations',
  POLICIES: 'policies',
  DATA_UNIFICATION: 'data-unification',
  DATA_UNIFICATION_ENTITIES: 'data-entities', // done
  DATA_UNIFICATION_ENTITY_MERGE: 'entity-merge',
  ASSET_AGING: 'asset-aging',
  DATA_PURGE: 'data-purge',
  AUTHENTICATION_SOURCES: 'authentication-sources',
  EXCEPTIONS: 'exceptions',
  EXCEPTIONS_SETTINGS: 'exceptions-settings',
  EXCEPTIONS_STATUSES: 'exceptions-statuses',
  FORMATTING_RULES: 'formatting-rules',
  EASM_SETTINGS: 'easm-settings',
  RISK360_BACKOFFICE_ACTIONS: 'risk360-backoffice-actions',
  TOOL_COVERAGE_AND_GAP: 'tool-coverage-and-gap',
  VIOLATION_TICKETS: 'violation-tickets',
  TICKET_LIFECYCLE: 'ticket-lifecycle',
  AUTOMATIONS: 'automations',
  ALERT_SCORE: 'alert-score',
  INCIDENT_RULES: 'incident-rules',
  SCANNERS_ACTIVATION: 'scanner-activation',
  TENANTS: 'tenants',
  IDENTITY_FINDINGS: 'identity-findings',
  USERS: 'users',
  ITDR_CONFIGURATION: 'itdr-config',
  EDIT_CUSTOM_ROLES: 'edit-custom-roles',
  IDNP_REMEDIATION_DASHBOARD: 'remediation',
  IDNP_OVERVIEW_DASHBOARD: 'overview',
  PIPELINE_MONITORING: 'pipeline-monitoring',
  PIPELINE_MONITORING_STATUS: 'status',
  PIPELINE_MONITORING_TRENDS: 'trends',
  AGENTS: 'agents',
  RISK_SCORE: 'risk-score',
  AGENTIC_SOC: 'agentic-soc',
  SOC_AUTOMATIONS: 'soc-automations',
  AUTOMATION_RULES: 'automation-rules',
  AUTOMATION_RULE_DETAILS: '$ruleId',
  PLAYBOOKS: 'playbooks',
  PLAYBOOK_DETAILS: '$playbookId',
  INCIDENT_LIFECYCLE: 'incident-lifecycle',
  RULE_ENGINE: 'rule-engine',
};

export const APP_PATHS = {
  ASSETS: 'assets',
  INCIDENTS: 'incidents',
  VULNERABILITIES: 'vulnerabilities',
  DETECTIONS: 'detections',
  PLATFORM: 'platform',
  EXPLORE: 'explore',
  SETTINGS: 'settings',
  RISK360: 'risk360',
  THREATS: 'threats',
  IDENTITIES: 'identities',
};
export type AppPathKey = keyof typeof APP_PATHS;

export type AppPathsValue = (typeof APP_PATHS)[keyof typeof APP_PATHS];
export const PUBLIC_APPS = [APP_PATHS.SETTINGS, APP_PATHS.EXPLORE, APP_PATHS.PLATFORM];
